import {
  formatPercentageValue,
  createKpiTileItem,
} from '../../../../utils/helper';
import { KpiHandler, UserInteractionData } from './types';
import { KpiData } from 'components/redesign/KpiTile/types';

const throughputEvents: KpiHandler = {
  type: 'KpiTile',
  handler: (data: UserInteractionData): KpiData => {
    const { throughputEvents, throughputEventsDelta } = data;

    const formattedValue = formatPercentageValue(throughputEvents);
    const tag = {
      text: formatPercentageValue(Math.abs(throughputEventsDelta)),
      isPositiveValue: throughputEventsDelta >= 0,
      sideLabel: '',
    };

    return createKpiTileItem(
      'Throughput Events',
      formattedValue,
      throughputEventsDelta ? tag : []
    );
  },
};

export default throughputEvents;
